import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CbDasherPipe} from './dasher.pipe';


@NgModule({
    declarations: [CbDasherPipe],
    imports: [
        CommonModule
    ],
    exports: [
        CbDasherPipe
    ]
})
export class CbDasherModule {
}
